import React, { Component } from 'react';
import { message, Table, TimePicker } from 'antd';
import moment from 'moment-timezone';
import { map } from 'lodash';
import Datatable from '../Component/Datatable';
import Loader from '../../../Common/Component/Loader';
import { errorHandle } from '../../../Common/errorHandle';

class Step1 extends Component {

  state = {
    field_staff: [],
    ffield_staff_pagination: {},
    loader: true,
    activePagination: '15',
    technicians: [],

  }


  componentDidMount = () => {
    // if(this.props && this.props.WeeklySetup && this.props.WeeklySetup.data && this.props.WeeklySetup.data.message){
    //      message.success('Services have been sent for scheduling and optimization.', 10);
    //  }

    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    const default_franchise_uuid = user?.user?.associated_field_offices[0].uuid;
    //Get Staff Details
    this.setState({
      loader: true
    });
    this.props.getFieldOfficeStaff({ 
      start_date: moment(this.props.weekStartDate).format('YYYY-MM-DD'),
      field_office__uuid : default_franchise_uuid,
      ordering:'user__first_name'
    });

    sessionStorage.removeItem('residentail_selected_row_keys');
    sessionStorage.removeItem('intial_selected_row_keys');
    sessionStorage.removeItem('commercial_selected_row_keys');
    // sessionStorage.removeItem('install_selected_row_keys');
    sessionStorage.removeItem('already_scheduled_intial_selected_row_keys');
    sessionStorage.removeItem('already_scheduled_residentail_selected_row_keys');
    sessionStorage.removeItem('already_scheduled_commercial_selected_row_keys');
    // sessionStorage.removeItem('already_scheduled_install_selected_row_keys');
  }

  UNSAFE_componentWillReceiveProps = async (props) => {
    let { ffield_staff_pagination } = this.state;
    let technician_list = [];

    // message.destroy();
    //get Staff List
    if (Object.keys(props.FieldStaff.data).length > 0 && props.FieldStaff.data !== this.props.FieldStaff.data) {
      // console.log("Field Technicians : ", props?.FieldStaff.data.results);
      ffield_staff_pagination.total = props.FieldStaff.data.count
      map(props?.FieldStaff.data.results, (item) => {
        technician_list.push({
          title: item?.user.first_name + " " + item?.user.last_name,
          technician_name: item?.user.first_name + " " + item?.user.last_name,
          technician_uuid: item?.uuid,
          id: item?.uuid,
          ftech_hours: item?.ftech_hours_of_work.filter(data => data.enable === true).map(data => data.date),
          service_count: item?.skillsets.filter(data => data.enable === true).length,
          user_uuid: item?.user?.uuid,
          inactive_days: [],
          classNames : ["filter-resource"]
        })
      });
      await this.props.handleTechnicianDetails(technician_list);
      if(this.props?.history?.location?.state?.query?.value === 'dashboard') {
        this.props.nextStep(2)
      }
      await this.setState({
        loader: false,
        field_staff: props.FieldStaff.data.results,
        technicians: technician_list
      })
      // setTimeout(() => {
      //   this.setState({ loader: false })
      // }, 5000);
    }

    if (Object.keys(props.FieldStaff.errors).length > 0 && props.FieldStaff.errors !== this.props.FieldStaff.errors) {
      this.setState({
        loader: false,
      });
      errorHandle(props?.FieldStaff?.errors);
    }

    //Update Staff
    if (Object.keys(props.UpdateStaff.data).length > 0 && props.UpdateStaff.data !== this.props.UpdateStaff.data) {
      map(props?.FieldStaff.data.results, (item) => {
        technician_list.push({
          title: item?.user.first_name + " " + item?.user.last_name,
          technician_name: item?.user.first_name + " " + item?.user.last_name,
          technician_uuid: item?.uuid,
          id: item?.uuid, //For displayng data because currently using user uuid
          ftech_hours: item?.ftech_hours_of_work.filter(data => data.enable === true).map(data => data.date),
          service_count: item?.skillsets.filter(data => data.enable === true).length,
          user_uuid: item?.user?.uuid,
          inactive_days: [],
          classNames : ["filter-resource"]
        })
      });
      this.props.handleTechnicianDetails(technician_list);
      this.setState({
        loader: false,
      })
      //Get Staff Details
      // this.props.getFieldOfficeStaff({ start_date: moment(moment().day(1)).format('YYYY-MM-DD') });

    }

    if (Object.keys(props.UpdateStaff.errors).length > 0 && props.UpdateStaff.errors !== this.props.UpdateStaff.errors) {
      // message.error('Something went wrong', 10);
      this.setState({
        loader: false,
      });
      errorHandle(props?.UpdateStaff?.errors);
    }

  }

  //Staff Skill Change
  stafCheckChange = (e, uuid, skill_uuid) => {
    let { field_staff } = this.state;

    let index = field_staff.findIndex(x => { return x.uuid === uuid });
    let index2 = field_staff[index]['skillsets'].findIndex(x => { return x.uuid === skill_uuid });

    field_staff[index]['skillsets'][index2]['enable'] = e.target.checked;


    //Update User API
    this.UpdateStaff(field_staff[index])

    this.setState({
      field_staff
    })
  }


  //Update Time
  updateStaffTime = (e, uuid, skill_uuid, type) => {
    let { field_staff } = this.state;
    let index = field_staff.findIndex(x => { return x.uuid === uuid });
    let index2 = field_staff[index]['ftech_hours_of_work'].findIndex(x => { return x.uuid === skill_uuid });
    field_staff[index]['ftech_hours_of_work'][index2][type] = moment(e).format('HH:mm:ss');

    //Update User API
    this.UpdateStaff(field_staff[index])

    this.setState({
      field_staff
    })
  }

  //Update Staff User
  UpdateStaff = (staff) => {
    // console.log(staff?.ftech_hours_of_work[0])
    this.props.updateFieldStaff({
      uuid: staff?.uuid,
      skillsets: staff?.skillsets,
      start_date: staff?.start_date,
      ftech_hours_of_work: staff?.ftech_hours_of_work
    });
    this.setState({ loader: true });

  }


  // Set price list as per invision
  arrayMove = (arr, fromIndex, toIndex) => {
    if (fromIndex && fromIndex >= 0) {
      var element = arr[fromIndex];
      arr.splice(fromIndex, 1);
      arr.splice(toIndex, 0, element);
    }
  };

  // Table Pagination
  paginationOnChange = (pagination, filters, sorter) => {
    let { field_staff_pagination } = this.state;
    let ordering = '';

    // field_staff_pagination = Object.assign(field_staff_pagination, { 'current': pagination.current });

    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `-user__first_name` : `user__first_name`
    }
    else {
      ordering = ''
    }


    this.props.getFieldOfficeStaff({ 
      start_date: moment(this.props.weekStartDate).format('YYYY-MM-DD'), 
      ordering,
      field_office__uuid : this.props.selected_franchise
    });


    this.setState({
      loader: true,
      field_staff_pagination
    })


  }
  // Staff Time Change
  setFieldTime = (uuid, skill_uuid) => {
    let { field_staff } = this.state;
    let index = field_staff.findIndex(x => { return x.uuid === uuid });
    let index2 = field_staff[index]['ftech_hours_of_work'].findIndex(x => { return x.uuid === skill_uuid });
    if (field_staff[index]['ftech_hours_of_work'][index2]['enable']) {
      field_staff[index]['ftech_hours_of_work'][index2]['enable'] = false;
      field_staff[index]['ftech_hours_of_work'][index2]['start_time'] = null;
      field_staff[index]['ftech_hours_of_work'][index2]['end_time'] = null;
    }
    else {
      var date = moment().format("YYYY-MM-DD");
      var time_start = "09:00";
      var time_end = "17:00";

      field_staff[index]['ftech_hours_of_work'][index2]['enable'] = true;
      field_staff[index]['ftech_hours_of_work'][index2]['start_time'] = moment(date + ' ' + time_start).format('HH:mm:ss');
      field_staff[index]['ftech_hours_of_work'][index2]['end_time'] = moment(date + ' ' + time_end).format('HH:mm:ss');
    }
    //Update User API
    this.UpdateStaff(field_staff[index])

    this.setState({
      field_staff
    })
  }
  //Render Working Hours
  renderWorkingHours = (record) => {


    let hoursOfWork = record?.ftech_hours_of_work;
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'mon'), 0);
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'tues'), 1);
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'wed'), 2);
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'thurs'), 3);
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'fri'), 4);
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'sat'), 5);
    this.arrayMove(hoursOfWork, hoursOfWork.findIndex((x) => x.day === 'sun'), 6);


    return map(hoursOfWork, (list, index) => {
      if (list?.day.charAt(0) === 'm') {
        // console.log("list.start_time:::>", list.start_time, "list.end_time:::>", moment(list.end_time, 'hh:mm'));
      }

      return (
        <li key={index}>
          <span
            onClick={() => {
              this.setFieldTime(record.uuid, list.uuid)
            }}
            className={!list.enable ? 'day-name text-capitalize doff' : 'day-name text-capitalize'}>{list?.day.charAt(0)}

            <div className="time_tool_tip">
              <label>{moment(list.date).format('ddd')} {moment(list.date).format('MMM DD,YYYY')}</label>
              {list.enable ?
                <p>Uncheck this date if a field technician is unavailable to work this day, off sick or on holiday.</p>
                : <p>Check this date if a field technician is available to work.</p>
              }
            </div>
          </span>
          <div className="work-time">
            <TimePicker
              className="swhite"
              disabled={!list.enable}
              placeholder='-'
              minuteStep={15}
              defaultPickerValue={moment()}
              value={list.enable ? moment(list.start_time, "hh:mm") : undefined}
              onChange={(e) => {
                this.updateStaffTime(e, record.uuid, list.uuid, 'start_time')
              }}
              allowClear={false}
              format={'h:mm A'} />
            <TimePicker
              className="swhite"
              disabled={!list.enable}
              placeholder='-'
              minuteStep={15}
              defaultPickerValue={moment()}
              value={list.enable ? moment(list.end_time, "hh:mm") : undefined}
              onChange={(e) => {
                this.updateStaffTime(e, record.uuid, list.uuid, 'end_time')
              }}
              allowClear={false}
              format={'h:mm A'} />
          </div>
        </li>
      )
    })

  }


  setPageLimit = (value) => {
    this.setState({ loader: true });
    let { ffield_staff_pagination } = this.state;
    Object.assign(ffield_staff_pagination, { current: 1, pageSize: value, ordering: '' });
    this.setState({ activePagination: value, ffield_staff_pagination, intialActivePagination: value });
    this.props.getFieldOfficeStaff({ 
      start_date: moment(this.props.weekStartDate).format('YYYY-MM-DD'),
      field_office__uuid : this.props.selected_franchise
    });

  }


  render() {
    let { field_staff, loader, ffield_staff_pagination, activePagination } = this.state;
    let { current } = this.props;
    return (
      <div className="main">

        <div className="filter_wrapper acc-wrap flex no-background p-0">
          <div className="left_side mr-2 d-block">
            <h6 className="mb-5">Step 1 of 2: Review Technicians</h6>
            <h3>OptimoRoute Scheduling</h3>
          </div>

          <div className="right_side">
            <div className="form-group flex ai-center w-100 flex-end">
              <div className="fitem max-width-84">
                <div className="justify-content-end">
                  {
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        this.props.nextStep(this.props.current === 0 ? 1 : this.props.current === 1 ? 2 : 0)
                      }}>
                      Next</button>}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Table
          rowKey={record => record.uuid}
          dataSource={field_staff}
          columns={Datatable.YourStaff(this)}
          pagination={ffield_staff_pagination}
          onChange={this.paginationOnChange}
        />

        {field_staff.length > 0 ?
          <ul className="pagination_page_size">
            <li>
              <span>Show:</span>
            </li>
            <li>
              <span
                onClick={() => { this.setPageLimit('15') }}
                className={activePagination === '15' ? 'active' : ''}
              >15</span>
            </li>
            <li>
              <span
                className={activePagination === '30' ? 'active' : ''}
                onClick={() => { this.setPageLimit('30') }}
              > 30</span>
            </li>
            <li>
              <span
                className={activePagination === '60' ? 'active' : ''}
                onClick={() => { this.setPageLimit('60') }}
              >60</span>
            </li>
          </ul>
          : ""
        }
        {loader ? <Loader /> : ''}
      </div>
    );
  }
}

export default Step1;